import { gql, useQuery } from "@apollo/client"
import type {
  Company,
  CountryIntelligenceOysterScore,
  CountryIsoCode,
  EmploymentTemplate,
  QueryEmploymentTemplateArgs,
} from "@oysterhr/schema"
import { EmploymentTemplateFragment } from "~/shared/fragments/EmploymentTemplateFragment"
import { buildId } from "@oysterhr/common"

export const EMPLOYMENT_TEMPLATE_QUERY = gql`
  query EmploymentTemplate(
    $id: ID
    $companyId: ID
    $countryCode: CountryIsoCode
    $oysterScore: CountryIntelligenceOysterScore
  ) {
    employmentTemplate(
      id: $id
      companyId: $companyId
      countryCode: $countryCode
      oysterScore: $oysterScore
    ) {
      ...EmploymentTemplateFragment
    }
  }
  ${EmploymentTemplateFragment}
`

interface EmploymentTemplateQueryProps {
  templateId?: string
  companyStrongId?: string
  countryCode?: CountryIsoCode
  oysterScore?: CountryIntelligenceOysterScore
}

export const useEmploymentTemplate = ({
  templateId,
  companyStrongId,
  countryCode,
  oysterScore,
}: EmploymentTemplateQueryProps) => {
  const { data, loading } = useQuery<
    { employmentTemplate: EmploymentTemplate },
    QueryEmploymentTemplateArgs
  >(EMPLOYMENT_TEMPLATE_QUERY, {
    variables: {
      id: buildId<EmploymentTemplate>("EmploymentTemplate", templateId),
      companyId: buildId<Company>("Company", companyStrongId),
      countryCode: countryCode,
      oysterScore: oysterScore,
    },
    skip: !templateId,
  })
  const employmentTemplate = data?.employmentTemplate
  return { employmentTemplate, loading }
}
